module.exports = __webpack_public_path__ + "fonts/_beachday.6588cfe0.ttf";